import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2024 SE Boot Camp - Steven Moses Alvarez</p>
    </footer>
  );
};

export default Footer;
